
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user-guide",
      function () {
        return require("private-next-pages/user-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user-guide"])
      });
    }
  